(function (angular) {
  "use strict";

  angular
    .module("fleetviewApp")
    .component("acceptTerms", {
      replace: false,
      template: require("./acceptterms.html"),
      controller: AcceptTermsController
    });

  AcceptTermsController.$inject = [
    "$location", "$http", "UserProvider", "alkAuthenticationService", "$rootScope"
  ];

  function AcceptTermsController($location, $http, UserProvider, alkAuthenticationService, $rootScope) {
    let vm = this;
    vm.isProcessing = false;
    vm.acceptTerms = acceptTerms;
    vm.language = $rootScope.language;

    function acceptTerms() {
      vm.isProcessing = true;

      alkAuthenticationService.acceptTerms()
        .then(() => {
          UserProvider.getUser().currentTermsOfUseAccepted = true;
          $location.url(getRedirectUrl());
        }, () => {
          vm.isProcessing = false;
        });
    }

    function getRedirectUrl() {
      let redirectTo = "/";

      if ($location.search().r) {
        redirectTo = decodeURIComponent($location.search().r);
      }

      return redirectTo;
    }
  }
})(window.angular);



// WEBPACK FOOTER //
// ./app/auth/terms.controller.js